import { render, staticRenderFns } from "./RewritePTDetailModal.vue?vue&type=template&id=31040411&"
import script from "./RewritePTDetailModal.vue?vue&type=script&lang=js&"
export * from "./RewritePTDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./RewritePTDetailModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports